/** Hands the browser a UTF-8 text file to save, as the offline license and activation flows do. */
export const downloadTextFile = (filename: string, contents: string): void => {
    const blob = new Blob([contents], { type: 'text/plain;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.click()
    URL.revokeObjectURL(url)
}
